import { BaseVariableProps, EmailVariables } from "../EmailBuilderTypes";
import VariableCollapse from "./VariableCollapse";
import AppMentionsInput from "../../../Inputs/AppMentionsInput";
import { useMemo } from "react";

interface Props extends BaseVariableProps {
  variables: EmailVariables[];
}

const TemplateValueBuilder = ({
  variable,
  variables,
  setVariables,
  index,
  customVariables,
  expandAll,
}: Props) => {
  if (variable.Type !== "TemplateValue") return null;

  const options = useMemo(() => {
    return variables.flatMap((variable, i) => {
      if (variable.Type === "SearchByEmail") return [];
      if (i === index) return [];

      return [
        {
          id: variable.Variable,
          display: variable.Variable,
        },
      ];
    });
  }, [variables]);

  const Builder = (
    <div className="px-4 pt-2 pb-4">
      <h4>Template Value</h4>
      <AppMentionsInput
        value={variable.Value}
        handleInputChange={handleInputChange}
        options={options}
      />
    </div>
  );

  return (
    <VariableCollapse
      variable={variable}
      setVariables={setVariables}
      index={index}
      customVariables={customVariables}
      expandAll={expandAll}
    >
      {Builder}
    </VariableCollapse>
  );

  function handleInputChange(_: any, newVal: string) {
    setVariables((prev) => {
      return prev.map((variable, i) => {
        if (i !== index) return variable;

        return { ...variable, Value: newVal };
      });
    });
  }
};

export default TemplateValueBuilder;
